var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8119 4.77813C17.226 4.789 17.5705 4.46214 17.5813 4.04807C17.5922 3.634 17.2654 3.28951 16.8513 3.27864L16.8119 4.77813ZM8.19324 18.9675C7.7805 19.0023 7.47414 19.3652 7.50897 19.7779C7.54381 20.1907 7.90665 20.497 8.31939 20.4622L8.19324 18.9675ZM16.8513 3.27864C15.6361 3.24674 14.1243 3.64061 12.872 4.57005C11.5968 5.51658 10.599 7.01529 10.4681 9.13159L11.9653 9.2242C12.067 7.58036 12.8202 6.47659 13.7661 5.77452C14.7349 5.05538 15.9143 4.75456 16.8119 4.77813L16.8513 3.27864ZM10.4681 9.13159C10.4046 10.159 10.5577 11.333 10.7101 12.4452C10.8672 13.5912 11.0262 14.6873 11.025 15.6761C11.0239 16.6692 10.8581 17.4261 10.4727 17.9521C10.111 18.4456 9.46174 18.8604 8.19324 18.9675L8.31939 20.4622C9.88521 20.33 10.9941 19.7782 11.6826 18.8387C12.3473 17.9316 12.5237 16.7892 12.525 15.6779C12.5263 14.5623 12.348 13.3489 12.1962 12.2415C12.0398 11.1002 11.9125 10.0768 11.9653 9.2242L10.4681 9.13159Z",
    fill: "#7B7986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15845 12.4058H15.2826",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormat);
export default __webpack_public_path__ + "static/media/format.fc83516e80229a85d193bf63fed500ce.svg";
export { ForwardRef as ReactComponent };